<template>
  <v-app>
    <div class="container">
      <!-- Header -->
      <header-simple></header-simple>

      <!-- Contents -->
      <div class="contents">

        <h1 class="title">
          This page can't be found
        </h1>

        <p class="message">
          Sorry, but we can't find the page you're looking for.<br>
          It might have been moved or deleted.<br>
          Check your spelling or click below to return to the homepage.
        </p>

        <router-link replace :to="{name: 'lab'}">
          <v-btn block depressed>
            Return to Lab
          </v-btn>
        </router-link>
      </div>

    </div>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Not Found"
    }
  },
}
</script>

<style scoped>
  .container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    background-color: #fff;
    max-width: 450px;
    width: 100%;
    border: 1px solid #dadce0;
    border-radius: 8px;
    padding: 22px 40px 38px;
    margin-top: 60px;
  }

  p {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/common/NotFound.vue